import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Percent = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M11.2 13.333a2.133 2.133 0 1 1 0-4.266 2.133 2.133 0 0 1 0 4.266Zm-6.4-6.4a2.133 2.133 0 1 1 0-4.266 2.133 2.133 0 0 1 0 4.266ZM11.2 12a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6ZM4.8 5.6a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Zm-1.14 7.682-.942-.942 9.622-9.623.943.943-9.623 9.622Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Percent;
